import { Outlet } from "react-router-dom"
import { Toaster } from "@/components/ui/toaster"

export default function BlankLayout() {
  return (
    <main className="container pt-8 pb-8 px-4 sm:px-8">
      <Toaster />
      <Outlet />
    </main>
  )
}
